(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href)
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1))
        if (card) {
          card.scrollIntoView({ behavior: 'instant' })
        }
      },
      { once: true }
    )
  }

  function syncProductGroupLayout() {
    const productGroups = document.querySelectorAll('.product-group-with-image')
    const allItems = []

    document.querySelectorAll('.product-grid__item').forEach((item) => {
      item.style.height = ''
      item.classList.remove('is-single-in-row')
    })

    // detect single row items
    productGroups.forEach((group) => {
      const grid = group.querySelector('.product-group-2x2')
      if (!grid) return

      const items = Array.from(grid.children)
      allItems.push(...items)

      const totalSlots = items.reduce((sum, item) => sum + (item.classList.contains('full-tile') ? 2 : 1), 0)
      if (totalSlots % 2 === 1) {
        const lastItem = items[items.length - 1]
        lastItem.classList.add('is-single-in-row')
      }
    })

    // set height to products
    if (allItems.length > 0) {
      const referenceHeight = allItems[0].offsetHeight

      allItems.forEach((item) => {
        item.style.height = `${referenceHeight}px`
        if (item.classList.contains('full-tile')) {
          item.classList.add('is-single-in-row')
        }
      })
    }

    if (window.innerWidth < 750) return

    // set height to the image container
    productGroups.forEach((group) => {
      const grid = group.querySelector('.product-group-2x2')
      const imageContainer = group.querySelector('.product-group-image')

      if (grid && imageContainer) {
        imageContainer.style.height = `${grid.offsetHeight}px`
      }
    })
  }

  document.addEventListener('DOMContentLoaded', syncProductGroupLayout)
  window.addEventListener('resize', syncProductGroupLayout)

  if (document.fonts) {
    document.fonts.ready.then(syncProductGroupLayout)
  }

  } catch(e) { console.error(e); }
})();
})();
